import { render } from "./document-colab.vue?vue&type=template&id=4b4a9716"
import script from "./document-colab.vue?vue&type=script&lang=js"
export * from "./document-colab.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__